import { render, staticRenderFns } from "./kefu.vue?vue&type=template&id=69aee2c9&scoped=true"
import script from "./kefu.vue?vue&type=script&lang=js"
export * from "./kefu.vue?vue&type=script&lang=js"
import style0 from "./kefu.vue?vue&type=style&index=0&id=69aee2c9&prod&lang=less"
import style1 from "./kefu.vue?vue&type=style&index=1&id=69aee2c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aee2c9",
  null
  
)

export default component.exports